import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CompGroup } from "userful-chronos-app-common-js/dist/models/group";
import Card from "../Card";
import CardHeader from "../header/CardHeader";
import { faFolder } from "@fortawesome/pro-solid-svg-icons";
import CardSubHeader from "../header/CardSubHeader";
import FolderActionsMenu from "../../dropdowns/FolderActionsMenu";
import Button from "../../button/Button";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons";
import Tag from "../../tag/Tag";
import UserfulTooltip from "../../Widgets/UserfulTooltip";
import { useTranslation } from "react-i18next";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    group: CompGroup;
    comps: CompGroup[];
    parent?: CompGroup;
    onMoveOut?: () => void;
    onDelete?: (id: string, recursive: boolean) => void;
    onEdit?: (group: CompGroup) => void;
}

export default function FolderCard({ group, comps, parent, onMoveOut, onDelete, onEdit, ...rest }: IProps) {
    const { t } = useTranslation();

    const { children: _children, ...htmlProps } = rest;

    return (
        <Card {...htmlProps}>
            <CardHeader>
                <CardSubHeader>
                    <UserfulTooltip placement="top" title={t("Decisions.SDL.Type.folder")}>
                        <Tag iconOnly variant={"yellow"}>
                            <FontAwesomeIcon icon={faFolder} />
                        </Tag>
                    </UserfulTooltip>
                    {group.name}
                </CardSubHeader>

                <FolderActionsMenu
                    value={group}
                    comps={comps}
                    parent={parent}
                    trigger={
                        <Button variant={"ghost"} iconOnly style={{ borderLeft: "1px solid #c6c8ce", borderRadius: 0 }}>
                            <FontAwesomeIcon icon={faEllipsis} />
                        </Button>
                    }
                    onMoveOut={onMoveOut ?? (() => {})}
                    onDelete={onDelete ?? (() => {})}
                    onEdit={onEdit ?? (() => {})}
                />
            </CardHeader>
        </Card>
    );
}
